"use strict";

import asyncAppend from "@elements/async-append";
import fetch from "@elements/fetch";
import formDataEntries from "form-data-entries";
import {isParsleyForm, loadParsley} from "@elements/parsley-bootstrap-validation";
import {getConfigValue} from "@elements/config-utils";
import {showNotification} from "@elements/alert-notification";
import initModulesInScope from "@elements/init-modules-in-scope";

let pendingRequest;

export function initInScope ($scope) {
    let $addBtn = $scope.find('.js-store-data__add');
    let $storeDataLoading = $scope.find('.js-store-data__loading');
    let $storeDataItems = $scope.find('.js-store-data-item');

    $addBtn.on('click', function () {
        let itemContainerSelector = $(this).data('store-data-target');
        let $itemContainer = $(itemContainerSelector);

        if (!$itemContainer.length) {
            console.warn('data-store-data-target missing for js-store-data__add');
            return;
        }

        $storeDataLoading.attr('hidden', null);

        let url = getConfigValue('storeDataAddUrl');
        pendingRequest = fetch(url, {
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
            },
            // body: params
        });

        showNotification(pendingRequest);

        pendingRequest.then((res) => {
            return res.clone().json();
        }).then((res) => {
            if (res.success) {
                let content = res.html || res.content;
                const $content = $(content);

                $itemContainer.append($content);
                initModulesInScope($content);
            }
            $storeDataLoading.attr('hidden', true);

        }).catch((error) => {
            if (error.name !== 'AbortError') {
                $storeDataLoading.attr('hidden', true);
                console.error(error);
            }
        });

    });

    $storeDataItems.each(function () {
        let $item = $(this);
        let $dataContainer = $item.find('.js-store-data-item__data');
        let $formContainer = $item.find('.js-store-data-item__form-container');
        let $loading = $item.find('.js-store-data-item__loading');
        let $form = $item.find('.js-store-data-item__form');

        let $storeDataHours = $item.find('.js-store-data-hours');

        addClickHandlers($item);

        $form.on('submit', function (evt) {
            evt.preventDefault();
            if(pendingRequest) {
                pendingRequest.abort();
                pendingRequest = null;
            }
            if (isParsleyForm($form)) {
                loadParsley().then(function () {
                    if ($form.data('Parsley')) {
                        $form.data('Parsley').whenValid().then(() => {

                            let url = $form.attr('action');
                            const data = formDataEntries($form[0]);
                            let params = new URLSearchParams(data);

                            pendingRequest = fetch(url, {
                                headers: {
                                    'pragma': 'no-cache',
                                    'cache-control': 'no-cache',
                                },
                                body: params
                            });

                            asyncAppend({
                                $target: $dataContainer,
                                $loading: $loading
                            }, pendingRequest)
                            .then((result) => {
                                if (result.success !== false) {
                                    $formContainer.attr('hidden', true);
                                    $dataContainer.attr('hidden', false);
                                    $item.find('.js-store-data-item__cancel').attr('hidden', false);
                                    // set data-id, so the delete-button will already work
                                    if (result.itemId !== null) {
                                        $item.data('store-data-item-id', result.itemId);
                                    }
                                    addClickHandlers($dataContainer);
                                }
                            });
                        })
                    }
                });
            }
        });

        $storeDataHours.each(function () {
            let $this = $(this);
            let $disableSelectsCB = $this.find('.js-store-data-hours__disable-selects');
            let $showRowTwo = $this.find('.js-store-data-hours__show-row');
            let $hideRowTwo = $this.find('.js-store-data-hours__hide-row');
            let $rowTwo = $this.find('.js-store-data-hours__row-two');

            $disableSelectsCB.on('change', function () {
                $this.find('select').attr('disabled', $(this).is(':checked'));
            });

            $showRowTwo.on('click', function () {
                if(!$disableSelectsCB.is(':checked')) {
                    $rowTwo.find('select').attr('disabled', false);
                }
                $rowTwo.attr('hidden', false);
                $showRowTwo.attr('hidden', true);
            });

            $hideRowTwo.on('click', function () {
                $rowTwo.find('select').attr('disabled', true);
                $rowTwo.attr('hidden', true);
                $showRowTwo.attr('hidden', false);
            })

        })
    });

    function addClickHandlers($scope) {
        let $toggleBtn = $scope.find('.js-store-data-item__toggle-form');
        let $deleteBtn = $scope.find('.js-store-data-item__delete');

        let $item = $scope.closest('.js-store-data-item');
        let $dataContainer = $item.find('.js-store-data-item__data');
        let $formContainer = $item.find('.js-store-data-item__form-container');
        let $loading = $item.find('.js-store-data-item__loading');

        $toggleBtn.on('click', function () {
            if ($formContainer.attr('hidden')) {
                $formContainer.attr('hidden', false);
                $dataContainer.attr('hidden', true);
            } else {
                $formContainer.attr('hidden', true);
                $dataContainer.attr('hidden', false);
            }
        });

        $deleteBtn.on('click', function () {
            // request removal and delete after success
            let $this = $(this);
            let id = $item.data('store-data-item-id');

            $loading.attr('hidden', null);

            let url = getConfigValue('storeDataDeleteUrl');
            pendingRequest = fetch(url, {
                headers: {
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache',
                },
                body: new URLSearchParams({
                    id: id
                })
            });

            showNotification(pendingRequest);

            pendingRequest.then((res) => {
                return res.clone().json();
            }).then((res) => {
                if (res.success) {
                    $this.closest('.modal').modal('hide');
                    $item.closest('.js-store-data-item-wrapper').remove();
                }

            }).catch((error) => {
                if (error.name !== 'AbortError') {
                    $loading.attr('hidden', true);
                    console.error(error);
                }
            });

        });
    }

}